<div>
  @if (!displayTableOnly) {
    <div class="title-container">
      <div class="payment-detail-contents">
        <h3 class="content-heading">Payment Details</h3>
      </div>
    </div>
    @if (invoice.paymentType === 'Check' && isConfirmationPage) {
      <div class="contents-warning">
        <mat-icon class="warning-icon md-24">warning</mat-icon>
        <span class="warning-content">Action Required</span>
      </div>
    }
    @if (displayEntityName(); as entityName) {
      <div class="contents">
        <h4 class="content-title">Invoice For</h4>
        <span>{{ entityName }}</span>
      </div>
    }
    <div class="contents">
      <h4 class="content-title">{{ transactionDateLabel }}</h4>
      <span>{{ invoice.createdOn | localDate }}</span>
    </div>
    @if (!invoice.paymentType) {
      <div class="contents">
        <h4 class="content-title">Invoice Number</h4>
        <span>{{ invoice.invoiceNumber }}</span>
      </div>
    }
    @if (!invoice.paymentType) {
      <div class="contents">
        <h4 class="content-title">Due Date</h4>
        <span>{{ invoice.dueDate | localDate }}</span>
      </div>
    }
    <div class="contents">
      <h4 class="content-title">{{ orderNumberLabel }}</h4>
      <span>{{ invoice.orderNumber }}</span>
    </div>
    @if (invoice.paymentTypeDisplay) {
      <div class="contents">
        <h4 class="content-title">Payment Type</h4>
        @if (!invoice.paymentDisplayHighlight) {
          <span>{{ invoice.paymentTypeDisplay }}</span>
        }
        @if (invoice.paymentDisplayHighlight) {
          <span
            >{{ invoice.paymentDisplayHighlight }} ({{
              invoice.paymentTypeDisplay
            }})</span
          >
        }
      </div>
    }
  }

  @for (item of invoice.invoiceLineItems; track item) {
    <div>
      <div class="table-rows">
        <span>{{ item.label }}</span>
        <span>{{ item.amount | currency }}</span>
      </div>
    </div>
  }
  @if (getTotalDisplay(); as totalDisplay) {
    <div class="payment-line-total" fxLayout>
      <div>{{ totalDisplay.label }}</div>
      <div>{{ totalDisplay.amount | currency }}</div>
    </div>
  }
  @if (invoice.paymentType === 'Check' && isConfirmationPage) {
    <div>
      <div class="contents-warning instructions">
        <mat-icon class="warning-icon md-24">warning</mat-icon>
        <span class="warning-content"
          >To complete payment, follow these instructions:</span
        >
      </div>
      <div class="contents">
        <div [innerHTML]="checkInstructions | safeHtml"></div>
      </div>
    </div>
  }
</div>
